import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { map, takeUntil, tap } from 'rxjs/operators';
import { Observable, of, Subject } from 'rxjs';
import { IOrganisation } from '@bciti/types';
import { Store } from '@ngrx/store';
import { State } from 'src/app/store';
import { organisationsLoadingSelector, organisationsSelector } from 'src/app/store/global/global.selectors';
import { Router } from '@angular/router';

@Component({
    selector: 'app-organisations',
    templateUrl: './organisations.component.html',
    styleUrls: ['./organisations.component.scss'],
})
export class OrganisationsComponent implements OnInit, OnDestroy {
    destroy$ = new Subject();
    dataSource: MatTableDataSource<Partial<IOrganisation>> = new MatTableDataSource<Partial<IOrganisation>>();

    displayedColumns: string[] = ['name', 'tag', 'timezone', 'bcitiId', 'actions'];

    isLoading$: Observable<Boolean> = this.store.select(organisationsLoadingSelector).pipe(
        takeUntil(this.destroy$),
        map((loading) => loading),
    );

    dataSource$: Observable<MatTableDataSource<Partial<IOrganisation>>> = this.store.select(organisationsSelector).pipe(
        takeUntil(this.destroy$),
        map((organisations) => {
            const dataSource = this.dataSource;

            dataSource.data = organisations.data;

            dataSource.filterPredicate = (data, filter) => {
                // Slight modification to the default Angular filterPredicate to only filter on the specified keys
                // https://www.angularjswiki.com/material/mat-table-filterpredicate/
                const filterKeys: string[] = ['name', 'tag', 'bcitiId'];

                const dataStr = Object.keys(data)
                    .reduce((currentTerm: string, key: string) => {
                        if (filterKeys.includes(key)) {
                            return currentTerm + (data as { [key: string]: any })[key] + '◬';
                        } else {
                            return currentTerm;
                        }
                    }, '')
                    .toLowerCase();

                const transformedFilter = filter.trim().toLowerCase();
                return dataStr.indexOf(transformedFilter) !== -1;
            };

            return dataSource;
        }),
    );

    constructor(private store: Store<State>, private router: Router) {}

    ngOnInit(): void {}

    applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.dataSource.filter = filterValue.trim().toLowerCase();
    }

    handleClick(e: Event, organisation) {
        this.router.navigate([`/organisation/${organisation.tag}`]);
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
